import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
import {
  Card,
  Stack,
  Typography,
  CircularProgress,
  useMediaQuery,
  FormControl,
  Select,
  OutlinedInput,
  MenuItem,
  TextField,
  Button,
} from '@mui/material';
import ClearButton from 'src/components/shared/ClearButton';
import FilterButton from 'src/components/shared/FilterButton';
import AddEntityButton from 'src/components/shared/AddEntityButton';
import DynamicTable from 'src/components/shared/DynamicTable';
import CustomFilter from 'src/components/filter/CustomFilter';
import FilterViewButton from 'src/components/shared/FilterViewButton';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useLocalization } from 'src/context/LocalizationContext';
import Iconify from 'src/components/iconify';
import { CustomerApprovalModal } from 'src/modals/CustomerApprovalModal';
import { tokenService } from 'src/services';
import QRModal from 'src/modals/QRModal';

export default function CheckroomOperations() {

  const poiID = tokenService.getUser().firstResponsibleOffice.id;
  const { language } = useLocalization();
  const [selected, setSelected] = useState([]);
  const [filterModal, setFilterModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectedStatus, setSelectedStatus] = useState([]);

  const [name, setName] = useState("");
  const [lastname, setLastname] = useState("");
  const [vestiyerNo, setVestiyerNo] = useState("");

  const [qrModalOpen, setQrModalOpen] = useState(false);
  const handleOpenQR = () => setQrModalOpen(true)
  const handleCloseQR = () => setQrModalOpen(false)

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const isMobile = useMediaQuery('(max-width:768px)');

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 0;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const StatusList = [
    {
      label: "Tamamlandı",
      id: "1"
    },
    {
      label: "İşlemde",
      id: "2"
    },
    {
      label: "Süre Aşıldı",
      id: "3"
    },

  ];

  const handleModal = () => {
    setFilterModal(true);
  };

  const handleCloseModal = () => {
    setFilterModal(false);
  };

  const handleCheckboxChange = (event, id, row) => {
    if (event.target.checked) {
      setSelected(prev => [...prev, id]);
    } else {
      setSelected(prev => prev.filter(item => item !== id));
    }
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelected(DUMMY_DATA.map(row => row.id));
    } else {
      setSelected([]);
    }
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedStatus(value);
  };

  const TABLE_HEAD = [
    { id: 'checkbox', label: '', alignRight: false, sx: { width: '20px' } },
    { id: 'no', label: 'No', alignRight: false, sx: { width: '20px' } },
    { id: 'checkroomInfo', label: 'Vestiyer Bilgisi', alignRight: false },
    { id: 'name', label: 'Ad', alignRight: false },
    { id: 'lastname', label: 'Soyad', alignRight: false },
    { id: 'checkroomNo', label: 'Vest. No', alignRight: false },
    { id: 'packageCount', label: 'P. Adedi', alignRight: false },
    { id: 'createdDateTime', label: 'Oluşturma Tarihi', alignRight: false },
    {
      id: 'status',
      label: 'Durum',
      alignRight: false,
      width: 15,
      format: (value, row) => {
        if (value === "1") {
          return (

            <span
              style={{
                backgroundColor: 'rgba(222, 247, 236, 1)',
                padding: '4px 12px 4px 10px',
                borderRadius: '6px',
                textAlign: 'center',
                color: 'rgba(3, 84, 63, 1)',
                border: 'none',
                fontSize: 14,
                fontWeight: 500,
                fontFamily: 'Inter',
                marginRight: '6px',
              }}
            >
              Tamamlandı
            </span>

          );
        } else if (value === "2") {
          return (
            <span
              style={{
                backgroundColor: 'rgba(237, 235, 254, 1)',
                padding: '4px 12px 4px 10px',
                borderRadius: '6px',
                textAlign: 'center',
                border: 'none',
                color: 'rgba(85, 33, 181, 1)',
                fontSize: 14,
                fontWeight: 500,
                fontFamily: 'Inter',
                marginRight: '6px',
              }}
            >
              İşlemde
            </span>
          );
        }

        else if (value === "3") {
          return (
            <span
              style={{
                backgroundColor: 'rgba(253, 232, 232, 1)',
                padding: '4px 12px 4px 10px',
                borderRadius: '6px',
                textAlign: 'center',
                border: 'none',
                color: 'rgba(155, 28, 28, 1)',
                fontSize: 14,
                fontWeight: 500,
                fontFamily: 'Inter',
                marginRight: '6px',
              }}
            >
              Süre Aşıldı
            </span>
          );
        }
      },
      sx: { width: '15%' },
    },
    {
      id: 'mNotu', label: 'M.Notu', alignRight: false, sx: { width: '20px' }, format: (value, row) => {
        return <Iconify style={{ cursor: 'pointer' }} icon={"garden:document-search-stroke-12"} color="rgba(156, 163, 175, 1)" onClick={() => console.log(row)} />;
      },
    },

  ];

  const handleApproveAll = (selectedData) => {
    console.log('Toplu Onay:', selectedData);
    // Seçili verilerle API çağrısı vs. yapılabilir.
  };

  // Tekli onay callback
  const handleApproveSingle = (row) => {
    console.log('Onaylandı:', row);
    // API çağrısı veya diğer işlemler burada yapılabilir.
  };


  const dummyDataVestiyer = [
    {
      id: 1,
      name: 'Furkan Aydemir',
      phone: '5555555555',
      vestiyerNo: '216487878',
      paketAdeti: 2,
      paketNotu: 'Acil teslimat'
    },
    {
      id: 2,
      name: 'Batuhan Göktaş',
      phone: '5555555555',
      vestiyerNo: '',
      paketAdeti: 3,
      paketNotu: 'Normal'
    },
    {
      id: 3,
      name: 'Oğuz Yusufoğlu',
      phone: '5555555555',
      vestiyerNo: '987654321',
      paketAdeti: 1,
      paketNotu: 'Kontrol gerektiriyor'
    },

  ];


  const DUMMY_DATA = [
    {
      id: 1,
      no: 1,
      checkroomInfo: 'İzmir İstinyepark',
      name: 'Batuhan',
      lastname: 'Göktaş',
      checkroomNo: '123',
      packageCount: 2,
      createdDateTime: '16.04.2024 11:18',
      status: '1',
    },
    {
      id: 2,
      no: 2,
      checkroomInfo: 'İzmir İstinyepark',
      name: 'Batuhan',
      lastname: 'Göktaş',
      checkroomNo: '123',
      packageCount: 2,
      createdDateTime: '16.04.2024 11:19',
      status: '2',
    },
    {
      id: 3,
      no: 3,
      checkroomInfo: 'İzmir İstinyepark',
      name: 'Batuhan',
      lastname: 'Göktaş',
      checkroomNo: '123',
      packageCount: 2,
      createdDateTime: '16.04.2024 11:20',
      status: '3',
    },
    {
      id: 4,
      no: 4,
      checkroomInfo: 'İzmir İstinyepark',
      name: 'Batuhan',
      lastname: 'Göktaş',
      checkroomNo: '123',
      packageCount: 2,
      createdDateTime: '16.04.2024 11:21',
      status: '1',
    },
    {
      id: 5,
      no: 5,
      checkroomInfo: 'İzmir İstinyepark',
      name: 'Batuhan',
      lastname: 'Göktaş',
      checkroomNo: '123',
      packageCount: 2,
      createdDateTime: '16.04.2024 11:22',
      status: '1',
    },
    {
      id: 6,
      no: 61,
      checkroomInfo: 'İzmir İstinyepark',
      name: 'Batuhan',
      lastname: 'Göktaş',
      checkroomNo: '123',
      packageCount: 2,
      createdDateTime: '16.04.2024 11:23',
      status: '1',
    },
  ];


  return (
    <>
      <Helmet>
        <title> Vestiyer İşlemleri | Easy Point Panel </title>
      </Helmet>

      <Stack style={{ paddingInline: '25px' }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Vestiyer Listesi
          </Typography>
          <AddEntityButton onClick={handleOpenQR} label={"QR OLUŞTUR"} icon={"ic:baseline-qrcode"} />
        </Stack>
        <Stack
          direction="row"
          justifyContent={isMobile ? 'space-between' : 'end'}
          mb={5}
          paddingX={2}
        >
          {isMobile ? (
            <FilterViewButton variant="contained" onClick={handleModal} />
          ) : null}
        </Stack>
        <Card>
          <div style={{
            position: 'absolute',
            right: '44px',
            top: '15px',
            flexDirection: 'row',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>

            <span style={{ color: 'rgba(155, 154, 154, 1)', marginRight: '8px', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
              <Iconify icon={'ph:users-bold'} style={{ marginRight: '5px' }} /><span>Bekleyen Müşteri Talepleri:</span>
            </span>

            <Button variant="contained" onClick={handleOpen}
              sx={{
                backgroundColor: 'rgba(249, 250, 251, 1)',
                border: '1px solid rgba(234, 236, 240, 1)',
                color: 'rgba(52, 64, 84, 1)',
                boxShadow: 'none',
                fontWeight: '500',
                '&:hover': {
                  backgroundColor: 'rgba(249, 250, 251, 1)',
                  border: '1px solid rgb(193, 194, 196)'
                }
              }}>
              Talepler <span style={{ width: '21px', height: '21px', borderRadius: '100%', backgroundColor: 'rgba(255, 225, 225, 1)', color: 'rgba(219, 57, 57, 1)', alignItems: 'center', justifyContent: 'center', display: 'flex', marginLeft: '5px' }}>3</span>
            </Button>
          </div>

          <CustomFilter
            modalType={'drawer'}
            filterModal={filterModal}
            handleCloseModal={handleCloseModal}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-start"
              paddingY={2}
              paddingX={1}
            >
              <Stack
                mr={1}
                direction="column"
                alignItems="flex-start"
                justifyContent="flex-start"
                sx={{ marginBottom: 2 }}
                width="100%"
                spacing={2}
              >

                <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
                  <FormControl sx={{ flex: 1 }}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        sx={{ flex: 1 }}
                        format="DD/MM/YYYY"
                        label={language.commons.labels.start_date}
                        value={startDate}
                        onChange={(newValue) => setStartDate(newValue)}
                      />
                    </LocalizationProvider>
                  </FormControl>
                  <FormControl sx={{ flex: 1 }}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        sx={{ flex: 1 }}
                        format="DD/MM/YYYY"
                        label={language.commons.labels.end_date}
                        value={endDate}
                        onChange={(newValue) => setEndDate(newValue)}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Stack>

                <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
                  <FormControl sx={{ flex: 1 }}>
                    <Select
                      multiple
                      displayEmpty
                      value={selectedStatus}
                      input={<OutlinedInput />}
                      onChange={handleChange}
                      renderValue={(selected) => {
                        if (selected?.length === 0) {
                          return <em>{language.commons.status}</em>;
                        }

                        return selected.map((x) => x?.label).join(', ');
                      }}
                      MenuProps={MenuProps}
                      inputProps={{ 'aria-label': 'Without label' }}
                    >
                      {StatusList.map((x) => (
                        <MenuItem key={x.id} value={x}>
                          {x.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack>

                <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                  <TextField
                    label="Ad"
                    variant="outlined"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    sx={{ flex: 1 }}
                  />
                </FormControl>

                <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                  <TextField
                    label="Soyad"
                    variant="outlined"
                    value={lastname}
                    onChange={(e) => setLastname(e.target.value)}
                    sx={{ flex: 1 }}
                  />
                </FormControl>

                <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                  <TextField
                    label="Vestiyer No"
                    variant="outlined"
                    value={vestiyerNo}
                    onChange={(e) => setVestiyerNo(e.target.value)}
                    sx={{ flex: 1 }}
                  />
                </FormControl>

              </Stack>
            </Stack>
            <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
              <ClearButton />
              <FilterButton />
            </Stack>
          </CustomFilter>

          {isLoading ?
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                padding: '50px',
              }}
            >
              <CircularProgress size={24} color="inherit" />
            </div>
            :
            <div style={{ marginTop: '50px' }}>
              <DynamicTable
                data={DUMMY_DATA}
                headers={TABLE_HEAD}
                initialOrder={"createdDateTime"}
                initalOrderDirection={"desc"}
                isMobile={isMobile}
                handleModal={handleModal}
                handleCloseModal={handleCloseModal}
                selected={selected}
                handleCheckboxChange={handleCheckboxChange}
                handleSelectAll={handleSelectAll}
              />
            </div>

          }
        </Card>
      </Stack>

      <QRModal
        open={qrModalOpen}
        qrLink={"https://qr.easypointapi.com/?chs=700x700&cht=qr&chl=https://easydesk.easypoint.com.tr/?poi=" + poiID}
        onClose={handleCloseQR}
      />

      <CustomerApprovalModal
        open={open}
        onClose={handleClose}
        data={dummyDataVestiyer}
        onApproveAll={handleApproveAll}
        onApproveSingle={handleApproveSingle}
      />
    </>
  )
}
